import { CALL_API } from 'redux-api-middleware'
import {
  AUTH_PROFILE_RECEIVE,
  isNordEmployee,
  SET_SECURITY_QUESTIONS_REQUEST,
  SET_SECURITY_QUESTIONS_RECEIVE,
  SET_SECURITY_QUESTIONS_FAILURE
} from './authProfile'
import { reset } from 'redux-form'

export const PRESERVE_PASSWORD_ON_TOGGLE = 'securityQuestionsDialog/PRESERVE_PASSWORD_ON_TOGGLE'

export const SECURITY_QUESTIONS_SHOW_DIALOG = 'securityQuestionsDialog/SECURITY_QUESTIONS_SHOW_DIALOG'
export const STOCK_SECURITY_QUESTIONS_REQUEST = 'securityQuestionsDialog/STOCK_SECURITY_QUESTIONS_REQUEST'
export const STOCK_SECURITY_QUESTIONS_RECEIVE = 'securityQuestionsDialog/STOCK_SECURITY_QUESTIONS_RECEIVE'
export const STOCK_SECURITY_QUESTIONS_FAILURE = 'securityQuestionsDialog/STOCK_SECURITY_QUESTIONS_FAILURE'

const initialState = {
  fieldName: '',
  hasSetSecurityQuestion: true, // default true to allow app usage even if Security question fetch fails
  initialValues: {},
  isSubmitting: false,
  open: false,
  stockQuestions: []
}

export const reducer = (state = initialState, action) => {
  let init = {...state.initialValues}
  const preservedField = state.fieldName
  switch (action.type) {
    case AUTH_PROFILE_RECEIVE:
      const userInfo = action.payload
      return {
        ...state,
        hasSetSecurityQuestion: userInfo.hasRecoveryQuestion,
        initialValues: { email: isNordEmployee(userInfo) ? userInfo.email : userInfo.profile.email }
      }
    case PRESERVE_PASSWORD_ON_TOGGLE:
      const fieldName = action.fieldName
      const value = action.value
      if (fieldName && value) {
        init = { ...init, [fieldName]: value }
      }
      return {
        ...state,
        initialValues: init,
        fieldName
      }
    case SECURITY_QUESTIONS_SHOW_DIALOG:
      if (preservedField) {
        delete init[preservedField]
      }
      return {
        ...state,
        open: action.securityQuestionsDialogState,
        initialValues: init
      }
    case SET_SECURITY_QUESTIONS_REQUEST:
      return {
        ...state,
        isSubmitting: true,
      }
    case SET_SECURITY_QUESTIONS_RECEIVE:
      return {
        ...state,
        hasSetSecurityQuestion: true,
        isSubmitting: false,
        open: false
      }
    case SET_SECURITY_QUESTIONS_FAILURE:
      if (preservedField) {
        delete init[preservedField]
      }
      return {
        ...state,
        isSubmitting: false,
        initialValues: init
      }
    case STOCK_SECURITY_QUESTIONS_RECEIVE:
      return {
        ...state,
        stockQuestions: action.payload.data.items
      }
    default:
      return state
  }
}

export const resetSecurityForm = () => {
  return (dispatch) => {
    dispatch(reset('securityQuestionsFormDialog'))
  }
}

export const preserveReduxFormValueOnToggle = (fieldName, value) => ({ type: PRESERVE_PASSWORD_ON_TOGGLE, fieldName, value })
export const showSecurityQuestionsDialog = (securityQuestionsDialogState) => ({ type: SECURITY_QUESTIONS_SHOW_DIALOG, securityQuestionsDialogState })

export const fetchStockSecurityQuestions = () => {
  const authZEndpoint = '/api/v1/authz/securityquestions'
  return {
    [CALL_API]: {
      endpoint: isLocal() ? `http://localhost:8080${authZEndpoint}` : authZEndpoint,
      method: 'GET',
      credentials: 'include',
      types: [STOCK_SECURITY_QUESTIONS_REQUEST, STOCK_SECURITY_QUESTIONS_RECEIVE, STOCK_SECURITY_QUESTIONS_FAILURE]
    }
  }
}

function isLocal() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
}

export default reducer
